export default __webpack_public_path__ + "static/subset-UniNeueBold-Italic-ea8cb8e16bbb0c3895186ba3134a4fc4.woff";